import {
  capitalize,
  Stepper as MuiStepper,
  StepperProps as MuiStepperProps,
} from '@mui/material';
import clsx from 'clsx';

import { InternalContext } from './InternalContext';
import { Step } from './Step';
import { StepperSize } from './types';

export type StepperProps = MuiStepperProps<
  'div',
  {
    inverse?: boolean;
    size?: StepperSize;
    steps?: number;
    testId?: string;
  }
>;

export const Stepper = ({
  inverse = false,
  size = 'medium',
  className,
  children,
  steps,
  testId,
  ...rest
}: StepperProps) => {
  if (!children && !steps) {
    return null;
  }
  return (
    <InternalContext.Provider value={{ size, inverse }}>
      <MuiStepper
        className={clsx(
          'DS-Stepper-root',
          `DS-Stepper-size${capitalize(size)}`,
          inverse && 'DS-Stepper-inverse',
          className
        )}
        data-testid={testId}
        {...rest}
      >
        {children ||
          [...Array(steps)].map((_, index) => (
            <Step key={index} content={(index + 1).toString()} />
          ))}
      </MuiStepper>
    </InternalContext.Provider>
  );
};
